import React, { FC } from 'react';

const iconCactus = require('./icon_cactus.svg');

export const IconCactus: FC = () => {
  return <img src={iconCactus} width={59} height={82} alt="icon_cactus" />;
};

IconCactus.displayName = 'IconCactus';
